<template>
  <div>
    <CommonHead></CommonHead>
    <div class="signup">
      <b-jumbotron class="pl-0 pr-0" container-fluid="true" bg-variant="white">
        <b-container fluid>
          <b-row>
            <b-col>
              <div class="register-form onlineform">
                <h1>Account Application</h1>
                <p class="info_note">Hello, and thank you for your inquiry into opening an account with our company.</p>
                <p class="info_note">RM COCO Décor Ltd is a to-the-trade wholesaler. As such, we only sell our products and services to qualified design firms, workrooms, and home décor businesses. It would be our pleasure to have you join our growing list of customers.</p>
                <p class="info_note">Once we have reviewed your application, the RM COCO sales representative for your area will contact you to complete the registration process.</p>
                <p class="info_note">Complete the form below for online access and ordering.</p>
                <div class="sign_up">
                  <b-form class="commonform" @submit="onSubmit" enctype="multipart/form-data">
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.businessname" :class="allerrors.businessname?'haserror forstar':'forstar'" :invalid-feedback="allerrors.businessname">
                          <label>Legal Name of Business</label>
                          <md-input :state="!allerrors.businessname" v-model="form.businessname" type="text" @input="delete allerrors['businessname']"></md-input>
                          <span class="error-msg" v-if="allerrors.businessname">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.dba" :class="allerrors.dba?'haserror forstar':'forstar'" :invalid-feedback="allerrors.dba">
                          <label>DBA</label>
                          <md-input :state="!allerrors.dba" v-model="form.dba" type="text" @input="delete allerrors['dba']"></md-input>
                          <span class="error-msg" v-if="allerrors.dba">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Mailing Address</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.mailstreetaddress" :class="allerrors.mailstreetaddress?'haserror forstar':'forstar'" :invalid-feedback="allerrors.mailstreetaddress">
                          <label>Street Address</label>
                          <md-input :state="!allerrors.mailstreetaddress" v-model="form.mailstreetaddress" type="text" @input="delete allerrors['mailstreetaddress']"></md-input>
                          <span class="error-msg" v-if="allerrors.mailstreetaddress">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.mailcity" :class="allerrors.mailcity?'haserror forstar':'forstar'" :invalid-feedback="allerrors.mailcity">
                          <label>City</label>
                          <md-input :state="!allerrors.mailcity" v-model="form.mailcity" type="text" @input="delete allerrors['mailcity']"></md-input>
                          <span class="error-msg" v-if="allerrors.mailcity">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.mailstate" :class="allerrors.mailstate?'haserror forstar':'forstar'" :invalid-feedback="allerrors.mailstate">
                          <label>State</label>
                          <md-input :state="!allerrors.mailstate" v-model="form.mailstate" type="text" @input="delete allerrors['mailstate']"></md-input>
                          <span class="error-msg" v-if="allerrors.mailstate">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.mailzipcode" :class="allerrors.mailzipcode?'haserror forstar':'forstar'" :invalid-feedback="allerrors.mailzipcode">
                          <label>Zip Code</label>
                          <md-input :state="!allerrors.mailzipcode" v-model="form.mailzipcode" type="number" @input="delete allerrors['mailzipcode']"></md-input>
                          <span class="error-msg" v-if="allerrors.mailzipcode">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.mailcountry" :class="allerrors.mailcountry?'haserror forstar':'forstar'" :invalid-feedback="allerrors.mailcountry">
                          <label>Country</label>
                          <md-input :state="!allerrors.mailcountry" v-model="form.mailcountry" type="text" @input="delete allerrors['mailcountry']"></md-input>
                          <span class="error-msg" v-if="allerrors.mailcountry">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Shipping Address</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.shipstreetaddress" :class="allerrors.shipstreetaddress?'haserror forstar':'forstar'" :invalid-feedback="allerrors.shipstreetaddress">
                          <label>Street Address</label>
                          <md-input :state="!allerrors.shipstreetaddress" v-model="form.shipstreetaddress" type="text" @input="delete allerrors['shipstreetaddress']"></md-input>
                          <span class="error-msg" v-if="allerrors.shipstreetaddress">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.shipcity" :class="allerrors.shipcity?'haserror forstar':'forstar'" :invalid-feedback="allerrors.shipcity">
                          <label>City</label>
                          <md-input :state="!allerrors.shipcity" v-model="form.shipcity" type="text" @input="delete allerrors['shipcity']"></md-input>
                          <span class="error-msg" v-if="allerrors.shipcity">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.shipstate" :class="allerrors.shipstate?'haserror forstar':'forstar'" :invalid-feedback="allerrors.shipstate">
                          <label>State</label>
                          <md-input :state="!allerrors.shipstate" v-model="form.shipstate" type="text" @input="delete allerrors['shipstate']"></md-input>
                          <span class="error-msg" v-if="allerrors.shipstate">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.shipzipcode" :class="allerrors.shipzipcode?'haserror forstar':'forstar'" :invalid-feedback="allerrors.shipzipcode">
                          <label>Zip Code</label>
                          <md-input :state="!allerrors.shipzipcode" v-model="form.shipzipcode" type="number" @input="delete allerrors['shipzipcode']"></md-input>
                          <span class="error-msg" v-if="allerrors.shipzipcode">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.shipcountry" :class="allerrors.shipcountry?'haserror forstar':'forstar'" :invalid-feedback="allerrors.shipcountry">
                          <label>Country</label>
                          <md-input :state="!allerrors.shipcountry" v-model="form.shipcountry" type="text" @input="delete allerrors['shipcountry']"></md-input>
                          <span class="error-msg" v-if="allerrors.shipcountry">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="3">
                        <md-radio v-model="form.shipaddressfor" value="residential">Residential</md-radio>
                      </b-col>
                      <b-col cols="3">
                        <md-radio v-model="form.shipaddressfor" value="commercial">Commercial</md-radio>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Company Info</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.phoneno" :class="allerrors.phoneno?'haserror forstar':'forstar'" :invalid-feedback="allerrors.phoneno">
                          <label>Business Phone</label>
                          <md-input :state="!allerrors.phoneno" v-model="form.phoneno" type="text" @input="delete allerrors['phoneno']"></md-input>
                          <span class="error-msg" v-if="allerrors.phoneno">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.email" :class="allerrors.email?'haserror forstar':'forstar'" :invalid-feedback="allerrors.email">
                          <label>Email</label>
                          <md-input :state="!allerrors.email" v-model="form.email" type="email" @input="delete allerrors['email']"></md-input>
                          <span class="error-msg" v-if="allerrors.email">{{allerrors.email=="The email field is required."?'Required Field':allerrors.email}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field>
                          <label>Fax No.</label>
                          <md-input v-model="form.faxno" type="text"></md-input>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field>
                          <label>Website</label>
                          <md-input v-model="form.website" type="text"></md-input>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row :class="allerrors.companytype?'haserror':''">
                      <b-col class="forstar">
                        <label>Type of Company: </label>
                      </b-col>
                      <b-col>
                        <md-radio :state="!allerrors.companytype" v-model="form.companytype" value="Corporation" @change="delete allerrors['companytype']">Corporation</md-radio>
                      </b-col>
                      <b-col>
                        <md-radio :state="!allerrors.companytype" v-model="form.companytype" value="LLC" @change="delete allerrors['companytype']">LLC</md-radio>
                      </b-col>
                      <b-col>
                        <md-radio :state="!allerrors.companytype" v-model="form.companytype" value="Partnership" @change="delete allerrors['companytype']">Partnership</md-radio>
                      </b-col>
                      <b-col>
                        <md-radio :state="!allerrors.companytype" v-model="form.companytype" value="Sole Owner" @change="delete allerrors['companytype']">Sole Owner</md-radio>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :state="!allerrors.stateofincorporation" :class="allerrors.stateofincorporation?'haserror forstar':'forstar'" :invalid-feedback="allerrors.stateofincorporation">
                          <label>State of Incorporation</label>
                          <md-input :state="!allerrors.stateofincorporation" v-model="form.stateofincorporation" type="text" @input="delete allerrors['stateofincorporation']"></md-input>
                          <span class="error-msg" v-if="allerrors.stateofincorporation">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col>
                        <md-field :state="!allerrors.datebusinessbegan" :class="allerrors.datebusinessbegan?'haserror forstar':'forstar'" :invalid-feedback="allerrors.datebusinessbegan">
                          <label>Dated Incorporated</label>
                          <md-input :state="!allerrors.datebusinessbegan" v-model="form.datebusinessbegan" type="text" @input="delete allerrors['datebusinessbegan']"></md-input>
                          <span class="error-msg" v-if="allerrors.datebusinessbegan">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field :state="!allerrors.federaltaxidno" :class="allerrors.federaltaxidno?'haserror forstar':'forstar'" :invalid-feedback="allerrors.federaltaxidno">
                          <label>Federal Tax ID</label>
                          <md-input :state="!allerrors.federaltaxidno" v-model="form.federaltaxidno" type="text" @input="delete allerrors['federaltaxidno']"></md-input>
                          <span class="error-msg" v-if="allerrors.federaltaxidno">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Business Owner</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field :state="!allerrors.ownername" :class="allerrors.ownername?'haserror forstar':'forstar'" :invalid-feedback="allerrors.ownername">
                          <label>Name</label>
                          <md-input :state="!allerrors.ownername" v-model="form.ownername" type="text" @input="delete allerrors['ownername']"></md-input>
                          <span class="error-msg" v-if="allerrors.ownername">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col cols="6">
                        <md-field :state="!allerrors.owneremail" :class="allerrors.owneremail?'haserror forstar':'forstar'" :invalid-feedback="allerrors.owneremail">
                          <label>Email</label>
                          <md-input :state="!allerrors.owneremail" v-model="form.owneremail" type="text" @input="delete allerrors['owneremail']"></md-input>
                          <span class="error-msg" v-if="allerrors.owneremail">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Accounts Payable Supervisor</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field :state="!allerrors.accountsname" :class="allerrors.accountsname?'haserror forstar':'forstar'" :invalid-feedback="allerrors.accountsname">
                          <label>Name</label>
                          <md-input :state="!allerrors.accountsname" v-model="form.accountsname" type="text" @input="delete allerrors['accountsname']"></md-input>
                          <span class="error-msg" v-if="allerrors.accountsname">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col cols="6">
                        <md-field :state="!allerrors.accountsemail" :class="allerrors.accountsemail?'haserror forstar':'forstar'" :invalid-feedback="allerrors.accountsemail">
                          <label>Email</label>
                          <md-input :state="!allerrors.accountsemail" v-model="form.accountsemail" type="text" @input="delete allerrors['accountsemail']"></md-input>
                          <span class="md-helper-text">(invoices will be sent to this address)</span>
                          <span class="error-msg" v-if="allerrors.accountsemail">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Buyer</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field :state="!allerrors.buyername" :class="allerrors.buyername?'haserror forstar':'forstar'" :invalid-feedback="allerrors.buyername">
                          <label>Name</label>
                          <md-input :state="!allerrors.buyername" v-model="form.buyername" type="text" @input="delete allerrors['buyername']"></md-input>
                          <span class="error-msg" v-if="allerrors.buyername">Required Field</span>
                        </md-field>
                      </b-col>
                      <b-col cols="6">
                        <md-field :state="!allerrors.buyeremail" :class="allerrors.buyeremail?'haserror forstar':'forstar'" :invalid-feedback="allerrors.buyeremail">
                          <label>Email</label>
                          <md-input :state="!allerrors.buyeremail" v-model="form.buyeremail" type="text" @input="delete allerrors['buyeremail']"></md-input>
                          <span class="md-helper-text">(order confirmations will be sent to this address)</span>
                          <span class="error-msg" v-if="allerrors.buyeremail">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Fabric Trade References(check all that apply)</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Robert Allen/Duralee">Robert Allen/Duralee</md-checkbox>
                      </b-col>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Kravet">Kravet</md-checkbox>
                      </b-col>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Carole">Carole</md-checkbox>
                      </b-col>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Kasmir">Kasmir</md-checkbox>
                      </b-col>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Pindler">Pindler</md-checkbox>
                      </b-col>
                      <b-col>
                        <md-checkbox v-model="form.fabrictrade" value="Fabricut">Fabricut</md-checkbox>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col class="forstar">
                        <h3 class="text-left"><label>How did you learn of RM COCO?</label></h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <md-field :state="!allerrors.knowaboutby" :class="allerrors.knowaboutby?'haserror forstar':'forstar'" :invalid-feedback="allerrors.knowaboutby">
                          <v-select
                              class="style-chooser"
                              :state="!allerrors.knowaboutby"
                              :options="knowabouts"
                              v-model="form.knowaboutby"
                              @input="delete allerrors['knowaboutby']"
                              placeholder=""
                          ></v-select>
                          <span class="error-msg" v-if="allerrors.knowaboutby">Required Field</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row :class="allerrors.companytype?'haserror':''">
                      <b-col class="forstar">
                        <h3 class="text-left"><label>Resale Tax Certificate</label></h3>
                        <p class="mt-4">RM COCO is required to tax all shipments in Missouri, Illinois, Texas, Washington, and Pennsylvania unless a completed tax exempt form is on file. A copy of your exemption certificate should accompany this application. It is also mandatory that applicant keep an updated certificate on file with Seller.</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :class="allerrors.files?'haserror':''">
                          <input type="file" id="files" name="files[]" ref="files" multiple @change="handleFilesUpload()" accept=".pdf, .doc, .docx">
                          <span class="col pl-0 pr-0 error-msg" v-if="allerrors.files">Required Field</span>
                          <p class="text-danger">{{multiplefile}}</p>
                        </md-field>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Terms & Conditions</h3>
                        <p class="mt-4">All new accounts will be automatically set up on a credit card basis as a convenience to the customer to expedite the account process.</p>
                      </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                      <b-col>
                        <h3 class="text-left">Comments Regarding Your Application</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field>
                          <md-textarea v-model="form.comments"></md-textarea>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <b-button class="mt-5" type="submit" block variant="dark">SUBMIT APPLICATION</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: "ErrorsMessages",
  components: {
    CommonHead,
    CommonFoot,
    'v-select': vSelect,
  },
  data() {
    return {
      valid_ext: ['pdf', 'doc', 'docx'],
      form: {
        businessname: '',
        dba: '',
        mailstreetaddress: '',
        mailcity: '',
        mailstate: '',
        mailcountry: '',
        mailzipcode: '',
        shipstreetaddress: '',
        shipcity: '',
        shipstate: '',
        shipcountry: '',
        shipzipcode: '',
        shipaddressfor:'commercial',
        phoneno: '',
        faxno: '',
        email: '',
        website:'',
        companytype: '',
        stateofincorporation: '',
        datebusinessbegan: '',
        federaltaxidno: '',
        ownername: '',
        owneremail: '',
        accountsname: '',
        accountsemail: '',
        buyername: '',
        buyeremail: '',
        fabrictrade: [],
        knowaboutby:'',
        comments:'',
        files: []
      },
      knowabouts :[
        'Referral',
        'ASID',
        'Tradeshow',
        'Magazine',
        'Google Search',
        'I was contacted by RM COCO rep',
        'Showroom Visit',
        'Instagram',
        'TikTok',
        'Facebook',
        'LinkedIn',
        'Houzz',
        'Other',
      ],
      multiplefile: '',
      allerrors: [],
      show: true
    };
  },
  beforeMount() {
    this.initForm();
  },
  computed: {
    
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.save();
    },
    handleFilesUpload(){
      let error = '';
      this.multiplefile = '';
      if(this.$refs.files.files.length > 0){  
        for( var i = 0; i < this.$refs.files.files.length; i++ ){
          let file = this.$refs.files.files[i];
          let file_ext = file.name.split('.')[1];
          if (this.valid_ext.indexOf(file_ext) === -1) {
            error += '1';
          }
        }
      }
      if(error != ''){
        this.$notify({
          text: "Invalid File format.",
          type: "error"
        });
        this.multiplefile = "Invalid File format only pdf,doc,docx allowed."
        return false;
      }else{
        return true;
      }
    },
    initForm() {
      this.form = new Form({
        businessname: '',
        dba: '',
        mailstreetaddress: '',
        mailcity: '',
        mailstate: '',
        mailcountry: '',
        mailzipcode: '',
        shipstreetaddress: '',
        shipcity: '',
        shipstate: '',
        shipcountry: '',
        shipzipcode: '',
        shipaddressfor:'commercial',
        phoneno: '',
        faxno: '',
        email: '',
        website:'',
        companytype: '',
        stateofincorporation: '',
        datebusinessbegan: '',
        federaltaxidno: '',
        ownername: '',
        owneremail: '',
        accountsname: '',
        accountsemail: '',
        buyername: '',
        buyeremail: '',
        fabrictrade: [],
        knowaboutby: '',
        comments: '',
        files: []
      });
    },
    save() {
      if(this.handleFilesUpload()){
        let formData = new FormData();
        formData.append('businessname',this.form.businessname);
        formData.append('dba',this.form.dba);
        formData.append('mailstreetaddress',this.form.mailstreetaddress);
        formData.append('mailcity',this.form.mailcity);
        formData.append('mailstate',this.form.mailstate);
        formData.append('mailcountry',this.form.mailcountry);
        formData.append('mailzipcode',this.form.mailzipcode);
        formData.append('shipstreetaddress',this.form.shipstreetaddress);
        formData.append('shipcity',this.form.shipcity);
        formData.append('shipstate',this.form.shipstate);
        formData.append('shipcountry',this.form.shipcountry);
        formData.append('shipzipcode',this.form.shipzipcode);
        formData.append('shipaddressfor',this.form.shipaddressfor);
        formData.append('phoneno',this.form.phoneno);
        formData.append('faxno',this.form.faxno);
        formData.append('email',this.form.email);
        formData.append('website',this.form.website);
        formData.append('companytype',this.form.companytype);
        formData.append('stateofincorporation',this.form.stateofincorporation);
        formData.append('datebusinessbegan',this.form.datebusinessbegan);
        formData.append('federaltaxidno',this.form.federaltaxidno);
        formData.append('ownername',this.form.ownername);
        formData.append('owneremail',this.form.owneremail);
        formData.append('accountsname',this.form.accountsname);
        formData.append('accountsemail',this.form.accountsemail);
        formData.append('buyername',this.form.buyername);
        formData.append('buyeremail',this.form.buyeremail);
        formData.append('fabrictrade',this.form.fabrictrade);
        formData.append('knowaboutby',this.form.knowaboutby);
        formData.append('comments',this.form.comments);
        if(this.$refs.files.files.length > 0){
          for( var i = 0; i < this.$refs.files.files.length; i++ ){
            let file = this.$refs.files.files[i];
            formData.append('files[' + i + ']', file);
          }
        }
        this.$store.dispatch("onlineFormRequest", formData).then(res => {
          this.initForm();
          this.$notify({
            text: "Thank you, we will email you shortly",
            type: "success"
          });
          this.$router.push("/shop/thank-you-for-applying");
        })
        .catch(error => {
          this.allerrors = error.response.data.errors
          if (error.response && error.response.data) {
            this.$notify({
              text:
                "There is a validation error. Please correct the fields outlined in red and try again.",
              type: "error"
            });
          } else {
            this.$notify({
              text: "Something went wrong!",
              type: "error"
            });
          }
        });
      }
    }
  }
};
</script>
<style>
.register-form.onlineform{
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding-bottom: 40px;
  padding-left: 0;
}
.register-form.onlineform .sign_up hr{
  margin-bottom: 40px;
  border-top: 1px solid #d2d2d2;
  margin-top: 28px;
}
.register-form.onlineform .haserror .md-radio .md-radio-label{
  color: #f00;
}
.register-form.onlineform .forstar label::after {
  content: '*';
  color: #f00;
  font-size: 20px;
}
</style>